import { createFileRoute, notFound } from '@tanstack/react-router'
import ContactPageHeader from '../../Pages/ContactPage/ContactPageHeader'
import ContactPage from '../../Pages/ContactPage/ContactPage'
import { ContactPage as ContactPageV2 } from '../../version2/pages/contact-page/contact-page'
import PageBody from '../../Pages/Layout/PageBody'
import LoadingSpinner from '../../Components/LoadingSpinner'
import ErrorComponent from '../../Components/ErrorComponent'
import { canViewRoute, migratedToV2 } from '@/State/Permissions/HasPermissions'
import SessionStore from '../../State/SessionStore'
import PermissionDenied from '../../Pages/PermissionDenied'
import DataStore from '../../State/DataStore'
import { router } from '../../App'
import ContactCollection from '../../State/Collections/ContactCollection'
import { setLayoutDefaults } from '@2/layout/layout-store'
import { getCacheItemById } from '@2/cache'
import { CenterPadPageBody } from '@2/layout/page-body'
import { trpc } from '../../system/trpc'
import { contactStore } from '../../version2/pages/contact-page/contact-store'
import { processTRPCData } from '../../Queries/fetchData'
import { cleanupNewEntity } from '../../Utils/deleteEntity'

export const Route = createFileRoute('/_private/contacts/$id')({
    beforeLoad: ({ params }) => {
        if (!canViewRoute(SessionStore.user, 'contact', params))
            throw new Error('Permission Denied')
        const contact = getCacheItemById('contacts', params.id)
        setLayoutDefaults({
            pageTitle: contact
                ? `${contact?.firstName ?? ''} ${contact?.lastName ?? ''} (${contact?.organisationName})`
                : 'Contact',
            subMenu: 'clients',
        })
    },
    errorComponent: ({ error, reset }) => {
        if (error.message === 'Permission Denied') return <PermissionDenied />
        return <ErrorComponent error={error} reset={reset} />
    },
    loader: async ({ params }) => await loader(params.id),
    pendingComponent: LoadingSpinner,
    component: Wrapper,
    onLeave: (match) => {
        const { id } = match.params
        const contact = ContactCollection.contactsById[id]
        if (
            contact &&
            !contact.createdAt &&
            match.pathname !== router.latestLocation.pathname
        ) {
            cleanupNewEntity(contact, 'contact')
        }
    },
})

const loader = async (id) => {
    const data = await trpc.legacy.getContactPageData.query({ id })
    const processedModels = processTRPCData(data)
    const contact = ContactCollection.contactsById[id]
    if (!contact) {
        throw notFound()
    }
    return processedModels
}
function Wrapper() {
    const { id } = Route.useParams()

    // The store now handles all the save toast logic internally
    contactStore.useSaveHandler()

    if (migratedToV2()) {
        return (
            <CenterPadPageBody>
                <ContactPageV2 contactId={id} />
            </CenterPadPageBody>
        )
    }

    return (
        <>
            <ContactPageHeader id={id} />
            <PageBody>
                <ContactPage contactId={id} />
            </PageBody>
        </>
    )
}
